import { Component, Input, OnInit } from '@angular/core';
import { ModalController, IonCheckbox } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent } from "@ionic/angular/standalone";
import { DisplayService } from "@qid/core";
import { SID } from '../../modules/sid';
import { DocumentAccess } from '../../modules/document-access';
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, AvatarRoundComponent } from '@qid/super';

@Component({
  selector: 'oneqid-nx-view-document-options',
  templateUrl: './view-document-options.page.html',
  styleUrls: ['./view-document-options.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    SuperButtonComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonCheckbox
  ],
})
export class ViewDocumentOptionsPage implements OnInit {

  @Input() sid: SID = null
  @Input() documentAccesses: DocumentAccess[] = []
  @Input() selectedAccess: DocumentAccess = null;
  @Input() onCreateDocument: () => {};

  constructor(private modalController: ModalController,
    private displayService: DisplayService
  ) { }

  ngOnInit() {
  }

  onAddNewClicked() {
    this.onCreateDocument()
    this.closeModal()
  }

  closeModal() {
    this.modalController.dismiss()
  }

  onDocSelected(access: any) {
    this.selectedAccess = access
    this.modalController.dismiss({
      selectedAccess: access
    })
  }
}
